import { render } from "./PropertiesOverview.vue?vue&type=template&id=77c4bc6a&scoped=true&ts=true"
import script from "./PropertiesOverview.vue?vue&type=script&lang=ts"
export * from "./PropertiesOverview.vue?vue&type=script&lang=ts"

import "./PropertiesOverview.vue?vue&type=style&index=0&id=77c4bc6a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c4bc6a"]])

export default __exports__